import React, { useContext, useEffect, useState } from 'react'
import Radio, { Option } from '@Components/Fields/Radio'
import Button from '@Components/Buttons/Button'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { OverclaimReportRequestDTO } from '@Entities/report/overclaim-report-request'
import { submitOverclaimsReportRequest } from '@App/api/routes/search'
import { ExportType } from '@App/enum/export-type'

interface ExportOverclaimsFormProps {
    setIsFormSubmitted: (isFormSubmitted: boolean) => void
}

const ExportOverclaimsForm = (props: ExportOverclaimsFormProps) => {
    const { exportStore, overclaimSearchStore, preloaderStore, rightsholderStore, popupStore } =
        useContext(StoresContext)
    const [format, setFormat] = useState('')

    useEffect(() => {
        const loadFormats = async () => {
            exportStore.setExportType(ExportType.OVERCLAIMS)
            try {
                await exportStore.loadExportFormats()
            } catch (error) {
                popupStore.setAlertFromError(error)
            } finally {
                preloaderStore.openTransparentPreloader(false)
            }
        }
        void loadFormats()
    }, [exportStore, popupStore, preloaderStore])

    const overclaimExportFormats: Option[] = exportStore.exportFormats
    const onFormatChange = (value: Option) => setFormat(value.value)

    const onSubmitOverclaimsExportRequest = async () => {
        if (!format) {
            return
        }
        preloaderStore.openTransparentPreloader(true)
        try {
            const request = new OverclaimReportRequestDTO(overclaimSearchStore.filteredOverclaimSearchQuery, format)
            await submitOverclaimsReportRequest(rightsholderStore.currentRightsholderId, request)
            props.setIsFormSubmitted(true)
        } catch (error) {
            popupStore.setAlertFromError(error)
        } finally {
            preloaderStore.openTransparentPreloader(false)
        }
    }

    return (
        <>
            <Radio
                options={overclaimExportFormats}
                field={{ name: 'File Type' }}
                direction="column"
                onChange={onFormatChange}
                title="File Type:"
            />
            <div className="download-button">
                <Button mainColor type="primary" disabled={!format} onClick={onSubmitOverclaimsExportRequest}>
                    Download
                </Button>
            </div>
        </>
    )
}

export default observer(ExportOverclaimsForm)
